import { Box, BoxProps, styled } from '@mui/material';
import { StyledComponent } from '@emotion/styled';
import { Theme } from '@mui/material/styles';

export const StyledDiv: StyledComponent<BoxProps & { theme?: Theme }> = styled(Box)(({ theme }) => ({
  '& .markDownRenderer_root': {
    fontFamily: theme.typography.fontFamily,
    backgroundColor: 'unset',
  },

  '& .markDownRenderer_ul': {
    padding: '0 40px',
  },

  '& .markDownRenderer_ol': {
    padding: '0 40px',
  },

  '& .markDownRenderer_code': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    fontFamily: 'Menlo, Consolas, Monaco, monospace',
    display: 'block',
    padding: '8px 8px 8px 52px',
    lineHeight: '1.53',
    fontSize: '13px',
    margin: '0',
    marginTop: '8px',
    marginBottom: '8px',
    overflowX: 'auto',
    position: 'relative',
    tabSize: 2,
    '&:before': {
      content: 'attr(data-gutter)',
      position: 'absolute',
      backgroundColor: theme.palette.action.selected,
      left: 0,
      top: 0,
      borderRight: `1px solid ${theme.palette.divider}`,
      padding: '8px',
      color: theme.palette.text.secondary,
      whiteSpace: 'pre-wrap',
      textAlign: 'right',
      minWidth: '25px',
    },
  },

  '& .markDownRenderer_textUnderline': {
    textDecoration: 'underline',
  },

  '& .markDownRenderer_textStrikethrough': {
    textDecoration: 'line-through',
  },

  '& .markDownRenderer_textUnderlineStrikethrough': {
    textDecoration: 'underline line-through',
  },

  '& .markDownRenderer_textSubscript': {
    fontSize: '0.8em',
    verticalAlign: 'sub',
  },

  '& .markDownRenderer_textSuperscript': {
    fontSize: '0.8em',
    verticalAlign: 'super',
  },
}));

export default StyledDiv;
